/* eslint react-native/no-unused-styles: 0 */
import { View } from '@gluestack-ui/themed'
import React, { FunctionComponent } from 'react'
import { Image, StyleSheet } from 'react-native'
import { MenuHeaderResult } from '../../api/Menu/types'
import { theme } from '../../theme'

const DrawerHeader: FunctionComponent<MenuHeaderResult> = props => {
  const headerStyles = styles(props.backgroundColor)

  return <View style={headerStyles.headerContainer}>{props.image && <Image style={headerStyles.image} source={{ uri: props.image }} resizeMode="contain" />}</View>
}

const styles = (color: string | null) =>
  StyleSheet.create({
    headerContainer: {
      height: theme.menu.header.imageHeight,
      backgroundColor: color || theme.colors.white,
    },
    image: {
      flex: 1,
    },
  })

export { DrawerHeader }
